import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import Slider, { Settings } from 'react-slick';
import { ArrowButton } from './ArrowButton';
import { CrossIcon } from '../Icons/CrossIcon';
import ScrollContainer from 'react-indiana-drag-scroll';
import { formatTripAdvisorPhotoUrl } from '../../../utils/reviews';

const SMALL_IMAGE_WIDTH = 174;
const SMALL_IMAGE_HEIGHT = 97;
const LARGE_IMAGE_WIDTH = 1384;
const LARGE_IMAGE_HEIGHT = 769;

export interface FullScreenCarouselProps {
    imagesCount: number;
    initialSlide?: number;
    title?: JSX.Element;
    getImageUrl?: (index: number, width: number, height: number) => string;
    getImageByIdx?: (idx: number) => string;
    onClose: () => void;
}

export interface StyledFullScreenCarouselProps
    extends JSSClassesProps<ComponentJSSClasses>,
        FullScreenCarouselProps {}

export class FullScreenCarousel extends React.Component<
    StyledFullScreenCarouselProps,
    {}
> {
    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    render() {
        const { classes } = this.props;

        const settings = {
            dots: true,
            dotsClass: 'slick-dots slick-thumb',
            initialSlide: this.props.initialSlide || 0,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <ArrowButton />,
            prevArrow: <ArrowButton />,
            appendDots: this.appendDots,
            customPaging: this.renderPaging,
            afterChange: this.afterChangeHandler,
        } as Settings;

        return (
            <div className={classes.container}>
                <p className={classes.title}>{this.props.title}</p>
                <button
                    className={classes.closeButton}
                    onClick={this.props.onClose}
                >
                    <CrossIcon />
                </button>
                <Slider {...settings}>
                    {Array.from(Array(this.props.imagesCount).keys()).map((i) =>
                        this.renderItem(i)
                    )}
                </Slider>
            </div>
        );
    }

    appendDots = (dots: any) => {
        return (
            <ScrollContainer horizontal={true}>
                <ul>{dots}</ul>
            </ScrollContainer>
        );
    }

    getSrc = (index: number, imageWidth?: number, imageHeight?: number, isPreview?: boolean ): string => {
        if (typeof this.props.getImageByIdx === 'function') {
            return formatTripAdvisorPhotoUrl(this.props.getImageByIdx(index), isPreview);
        }

        if (typeof this.props.getImageUrl === 'function' && imageHeight && imageWidth) {
            return this.props.getImageUrl(
                index,
                imageWidth,
                imageHeight
            );
        }

        return '';
    }

    renderPaging = (index: number) => {
        return (
            <a>
                <img src={this.getSrc(index, SMALL_IMAGE_WIDTH, SMALL_IMAGE_HEIGHT, true)} />
            </a>
        );
    }

    renderItem(index: number): JSX.Element | null {
        return (
            <div key={index}>
                <img src={this.getSrc(index, LARGE_IMAGE_WIDTH, LARGE_IMAGE_HEIGHT)} />
            </div>
        );
    }

    afterChangeHandler = (currentSlide: number) => {
        const pagingList = document.querySelector('.slick-slider .slick-dots');
        const activeElement = document.querySelector(
            '.slick-slider .slick-dots .slick-active'
        );

        if (!pagingList || !activeElement) {
            return;
        }

        const activeElementLeft = activeElement.getBoundingClientRect().left;

        if (
            activeElementLeft > 0 &&
            activeElementLeft + SMALL_IMAGE_WIDTH <=
                pagingList.getBoundingClientRect().width
        ) {
            return;
        }

        pagingList.scrollTo(activeElementLeft, 0);
    }

    componentWillUnmount() {
        document.body.style.overflow = 'unset';
    }
}
